import { Navigate, useParams } from 'react-router-dom';
import AuthService from '../modules/Admin/services/AuthService';
import usePipelineStages from '../modules/Admin/hooks/usePipelineStages';
import { isValidGuid } from '../shared/utils/guidValidation';
import { findStageIdByName, buildAssignedLeadsPath, statusNameKey } from '../modules/Admin/constants/leadConstants';
import { isEmployeeRole } from './roles';

const ALL_TIME_START = '2000-01-01';

function resolveStatusId(statusParam, stages) {
  if (!statusParam) return '';
  if (isValidGuid(statusParam)) return statusParam;
  const names = [statusParam];
  if (statusNameKey(statusParam).startsWith('callback')) {
    names.push('CallBackLater', 'ContactAfterSomeTime');
  }
  return findStageIdByName(stages, ...names);
}

/** Old dashboard filter URLs now open Assigned Leads with GUID status/date query params. */
export default function RedirectToAssignedLeads() {
  const { employeeId, fromDateParam, toDateParam, LeadStatusId } = useParams();
  const clientId = AuthService.getLoggedInClientId();
  const { stages, loading } = usePipelineStages({ clientId });
  const statusParam = LeadStatusId || '';
  const needsStages = Boolean(statusParam) && !isValidGuid(statusParam);

  if (needsStages && loading) return null;

  const omitAllTimeDates = fromDateParam === ALL_TIME_START;
  const to = buildAssignedLeadsPath({
    leadStatusId: resolveStatusId(statusParam, stages),
    fromDate: omitAllTimeDates ? undefined : fromDateParam,
    toDate: omitAllTimeDates ? undefined : toDateParam,
    assigneeUserId:
      !isEmployeeRole(AuthService.getLoggedInRoleId()) && isValidGuid(employeeId)
        ? employeeId
        : undefined,
  });

  return <Navigate to={to} replace />;
}
